import * as React from 'react';
import { translationKeyAt } from './renderedTranslations';
import { useTranslationEditor } from './TranslationEditorContext';

export function useTranslationKeyClicks() {
    const { selectKey } = useTranslationEditor();

    function handleClickCapture(event: React.MouseEvent<HTMLElement>) {
        const key = translationKeyAt(event.target);
        if (key === null) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        selectKey(key);
    }

    return { handleClickCapture };
}
